import { memo, useCallback, useEffect, useRef, useState } from 'react'
import { useContext } from 'use-context-selector'
import classNames from 'classnames'
import gsap from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'
import { createUseStyles } from 'react-jss'
import { Context as ScrollbarContext } from '@/context/scrollbar'
import useMediaQuery from '@/hooks/useMediaQuery'
import style from './style'

gsap.registerPlugin(ScrollToPlugin)

const useStyles = createUseStyles(style)

const ProductToolbar = ({
  items,
  visible,
  currentSection,
}) => {
  const classes = useStyles({ items: items.length })
  const { scrollbar } = useContext(ScrollbarContext)
  const [currentIndex, setCurrentIndex] = useState(0)
  const [hoverIndex, setCurrentHoverIndex] = useState(0)
  const { match: isMobile } = useMediaQuery('sm')
  const $root = useRef()
  const $activeBar = useRef()

  /*------------------------------
  Bar Animation
  ------------------------------*/
  const animateBar = useCallback((index, duration = 0.3) => {
    gsap.killTweensOf($activeBar.current)
    gsap.to($activeBar.current, {
      x: `${100 * index}%`,
      duration,
      ease: 'linear',
    })
  }, [])

  /*------------------------------
  Set Index of hovered item
  ------------------------------*/
  const handleMouseMove = useCallback((index) => {
    setCurrentHoverIndex(index)
  }, [])

  /*------------------------------
  Reverse animation to current index on mouse leave
  ------------------------------*/
  const handleMouseLeave = useCallback(() => {
    animateBar(currentIndex)
    setCurrentHoverIndex(currentIndex)
  }, [currentIndex])

  /*------------------------------
  Set index on click
  ------------------------------*/
  const handleClickItems = useCallback((item) => {
    if (item.anchor && scrollbar) scrollbar.scrollTo(item.anchor)
  }, [scrollbar])

  useEffect(() => {
    if (currentSection) {
      const index = items.findIndex((item) => item.anchor === currentSection)
      setCurrentIndex(index)
    }
  }, [currentSection])

  /*------------------------------
  Animate bar on change hover index
  ------------------------------*/
  useEffect(() => {
    animateBar(hoverIndex)
  }, [hoverIndex])

  /*------------------------------
  Change current index
  ------------------------------*/
  useEffect(() => {
    setCurrentHoverIndex(currentIndex)
  }, [currentIndex])

  return !isMobile && (
    <div
      ref={$root}
      className={classNames({
        [classes.root]: true,
        visible,
      })}
      onMouseLeave={handleMouseLeave}
    >
      <ul className={classes.toolbarNav}>
        {items.map((item, i) => (
          <li // eslint-disable-line
            key={i.toString()}
            onMouseMove={() => handleMouseMove(i)}
            onClick={() => handleClickItems(item, i)}
            className={classNames({
              [classes.active]: currentIndex === i,
            })}
          >
            <button
              aria-label={`go-to-${item.title}`}
            >
              {item.title}
            </button>
          </li>
        ))}
        <div
          ref={$activeBar}
          className={classes.activeBar}
        />
      </ul>
    </div>
  )
}

export default memo(ProductToolbar)
